// Badge riutilizzabili che mostrano il collegamento di un cambio corso:
// - sull'iscrizione ORIGINALE (variata / receduta) → cosa è cambiato + corso attivato
// - sulla NUOVA iscrizione (origine_variazione_id) → da quale corso proviene
// Usati in: Log iscrizioni (crono), Alunni » Corsi, Storico attività Extra.

const NUM_TO_G = { 0: "LUN", 1: "MAR", 2: "MER", 3: "GIO", 4: "VEN" };

const gg = (arr) => (arr || []).map((n) => NUM_TO_G[Number(n)]).filter(Boolean).join(", ") || "—";

const fmtD = (s) => {
  if (!s) return "";
  try {
    const d = new Date(s);
    if (!isNaN(d.getTime())) return d.toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" });
  } catch { /* noop */ }
  return String(s);
};

const badge = (color, bg) => ({
  fontSize: 10, fontWeight: 700, color, background: bg,
  border: `1px solid ${color}`, borderRadius: 3, padding: "2px 6px", lineHeight: 1.3,
});
const noteStyle = { fontSize: 9, fontWeight: 400, color: "#455a64", fontStyle: "italic", marginTop: 1 };

export default function VariazioneBadges({ it, compact }) {
  if (!it) return null;
  const items = [];

  if (it.variata) {
    const nuovi = (it.variazione_nuove || []).map((n) => n.corso_descrizione).filter(Boolean);
    const receduta = !!(String(it.data_recesso || "").trim()) && (it.giorni || []).length === 0;
    items.push(
      <div key="var" data-testid="badge-variata" style={badge("#6a1b9a", "#f3e5f5")}>
        {receduta ? (
          <span>⊘ Receduta il {fmtD(it.data_recesso || it.data_cambio)}
            {nuovi.length ? <> · sostituita da <b>{nuovi.join(", ")}</b></> : null}
          </span>
        ) : (
          <span>🔄 Variata il {fmtD(it.data_cambio)} · da <b>{gg(it.giorni_originali)}</b> → <b>{gg(it.giorni)}</b>
            {nuovi.length ? <> · attivato: <b>{nuovi.join(", ")}</b></> : null}
          </span>
        )}
        {!compact && it.note_variazione ? <div style={noteStyle}>📝 {it.note_variazione}</div> : null}
      </div>
    );
  }

  if (it.origine_variazione_id) {
    items.push(
      <div key="orig" data-testid="badge-origine" style={badge("#00695c", "#e0f2f1")}>
        <span>↳ da cambio corso
          {it.origine_corso_descrizione ? <> di <b>{it.origine_corso_descrizione}</b></> : null}
          {it.origine_data_cambio ? <> ({fmtD(it.origine_data_cambio)})</> : null}
        </span>
        {!compact && it.note_variazione && !it.variata ? <div style={noteStyle}>📝 {it.note_variazione}</div> : null}
      </div>
    );
  }

  if (!items.length) return null;
  return <div style={{ display: "flex", flexDirection: "column", gap: 3, marginTop: 4 }}>{items}</div>;
}
